module.exports = __webpack_public_path__ + "static/search-d7a970d6a7c9dc0a751aeceb3dd4c0e3.png";